import { ethers } from "ethers";
import {NETWORKID_ACTIVE, NETWORKID_ACTIVE_DEC} from '../utils/constants'
import { toast } from "react-toastify";

export const connectWallet = async (): Promise<string | null> => {
  if (!window.ethereum) {
    toast.error("MetaMask is not installed!");
    return null;
  }
  if (typeof window.ethereum !== "undefined" && window.ethereum) {
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      const selectedAccount = accounts[0];
      localStorage.setItem("walletAddress", selectedAccount); 
  
      const provider_network = new window.ethereum;
      const chainId = await provider_network.request({ method: "eth_chainId" });
      if(chainId !== NETWORKID_ACTIVE || chainId !== NETWORKID_ACTIVE_DEC){
        console.error(`NETWORK ERROR: ${chainId}`);
      }
  
      return selectedAccount; 
    } catch (error) {
      
      console.error("Wallet connection failed:", error);
      return null;
    }
  }else {
    return null;
  }

};


export const switchNetwork = async () => {
  if (!window.ethereum) {
    toast.error("MetaMask is not installed!");
    return;
  }

  try {
    await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: NETWORKID_ACTIVE }], 
    });

    const provider = new ethers.BrowserProvider(window.ethereum);
    const chainIdHex = await provider.send("eth_chainId", []);
    const chainId = parseInt(chainIdHex, 16).toString();
    localStorage.setItem("networkId", chainId);
 
    // window.location.reload();

  } catch (error: any) {
    if (error.code === 4902) {
      toast.error("BSC network is not added in MetaMask. Please add it manually.");
    } else {
      toast.error("Failed to switch network")
    }
  }

};
